import { render, staticRenderFns } from "./AccountSwitcher.vue?vue&type=template&id=0328d27c"
import script from "./AccountSwitcher.vue?vue&type=script&lang=js"
export * from "./AccountSwitcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NavigationNavLogo: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/navigation/NavLogo.vue').default})
